import './index.scss';

import ImgCobalt from '../../../assets/images/sobre-a-cobalt/quem-somos/img-cobalt@2x.png';

export const QuemSomos = () => {

    return (
        <div className='teste-cambio'>

            <div className='container-principal somos'>
                <div className='sombra-title'>
                    <h1> [ Quem somos ] </h1>
                </div>
            </div>

            <div className='restdados-somos'>
                <div className='paragraph-side' >
                    <p>
                        A Cobalt é uma fintech no ramo cambial que tem como seu principal objetivo
                        encontrar as melhores condições operacionais e de mercado de acordo com sua
                        necessidade.
                    </p>

                    <p>
                        Com base em nossa expertise no setor, entendemos que cada segmento tem sua
                        particularidade e suas características para a realização de operações de
                        câmbio tanto em pronto, trade finance e derivativos com fins de proteção.
                    </p>

                    <p>
                        Portanto, além de enquadrar sua operação na melhor opção disponível dentre
                        players de varejo ou nichados também, oferecemos uma consultoria especializada
                        na sua empresa.
                    </p>
                </div>
                <div className='data-side' >
                    <div>
                        <h1>100 milhões </h1>
                        <p> Movimentados por mês </p>
                    </div>
                    <div>
                        <h1>50 segmentos </h1>
                        <p> Atendidos </p>
                    </div>
                    <div>
                        <h1>10 instituições </h1>
                        <p> Financeiras integradas </p>
                    </div>
                    <div>
                        <h1>30 CORBAN </h1>
                        <p> Integralizados </p>
                    </div>
                </div>
            </div>

            <div className='list-itens' style={{ backgroundColor: '#F8F8F9' }}>
                <h1> Com a Cobalt, sua empresa <span style={{ fontWeight: 'bold' }}>ganha uma área cambial externa</span>, composta por três subdivisões:<br /> </h1>

                <h2> [ BackOffice de Câmbio ] </h2>
                <ul>
                    <li> Aprovação de documentação conforme operações realizadas </li>
                    <li> Análise de operação por operação </li>
                    <li> Verificação de viabilidade operacional </li>
                    <li> Operacionalização de pagamentos cambiais de acordo com sua necessidade (consultoria) </li>
                    <li> Redução de risco legal </li>
                </ul>

                <h2> [ Mesa de Operações e Tesouraria ] </h2>
                <ul>
                    <li> Realização de múltiplas cotações no momento do fechamento buscando a melhor taxa e condição operacional.  </li>
                    <li> Acompanhamento da precificação da moeda nos dias de operação. </li>
                    <li> Suporte no posicionamento das operações protegidas </li>
                </ul>

                <h2> [ Middle Office ] </h2>
                <ul>
                    <li> Cadastro em novos players liquidantes  </li>
                    <li> Acompanhamento do fechamento das operações até a liquidação assegurando envio e recebimento de todas as informações entre as casas </li>
                    <li> Monitoramento de volume operacional, entregas de atualizações e acompanhamento de análise de risco </li>
                </ul>
            </div>

            <div className='justify-cobalt'>
                <div className='cobalt-img'>
                    <img alt={ImgCobalt} src={ImgCobalt} />
                </div>
                <div className='cobalt-text'>
                    <h1> Porque Cobalt? </h1>
                    <p>
                        O <span style={{ fontWeight: 'bold' }}>Cobalto (Co)</span> é considerado um metal de raro de
                        transição, responsável por fazer a ligação química entre
                        metais. É um dos elementos principais na produção de
                        baterias de lítio de computadores e celulares, principais
                        dispositivos de acesso à tecnologia
                    </p>
                    <p style={{ fontWeight: 'bold' }}>
                        Nossa marca foi inspirada neste conceito, já que
                        nosso propósito, é fazer a transição de dados de
                        mercado e transformá-lo em inteligência através da
                        tecnologia.
                    </p>
                </div>
            </div>
        </div >
    )

}
